import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { VerificationVerifyingModel } from '../model';

type State =
  | { state: 'idle' | 'verified'; sid?: string }
  | {
      state: 'verifying' | 'sending-otp';
      data: VerificationVerifyingModel;
      sid?: string;
    };

const initialState: State = { state: 'idle' };

@Injectable()
export class PortalVerificationStore extends ComponentStore<State> {
  readonly verifyingState$ = this.select(s => (s.state === 'verifying' ? s : null));
  readonly isVerifying$ = this.select(s => s.state === 'verifying');
  readonly setVerifying = this.updater<VerificationVerifyingModel>((_, data) => ({ state: 'verifying', data }));
  readonly sendingOtpState$ = this.select(s => (s.state === 'sending-otp' ? s : null));
  readonly isSendingOtp$ = this.select(s => s.state === 'sending-otp');
  readonly setSendingOtp = this.updater<VerificationVerifyingModel>((state, data) => {
    if (state.state !== 'verifying') throw new Error('Invalid state');
    return { state: 'sending-otp', data: data };
  });
  readonly verifyTokenState$ = this.select(s => (s.state === 'verified' ? s : null));
  readonly isVerified$ = this.select(s => s.state === 'verified');
  readonly sid$ = this.select(s => s?.sid);
  readonly setSid = this.updater<string | undefined>((state, sid) => ({ ...state, sid }));

  constructor() {
    // console.log('Init PortalVerificationStore');
    super(initialState);
  }

  readonly setApplicantVerified = () => this.setState({ state: 'verified' });
}
